import React from 'react';
import PropTypes from 'prop-types';
import { TwitterOutlineIcon, LinkedinOutlineIcon, FacebookOutlineIcon } from '@bizzabo/icons';

const Props = {
    linkedin: PropTypes.string,
    facebook: PropTypes.string,
    twitter: PropTypes.string
};

const SocialsLinks = ({ linkedin, facebook, twitter }) => (
    <div className="speaker-socials margin-top-small bz-flex-row">
        {
            linkedin &&
                <div className="speaker-social">
                    <a href={linkedin} target="_blank">
                        <LinkedinOutlineIcon className="speaker-social-icon" width={32} height={32} />
                    </a>
                </div>
        }
        {
            facebook &&
                <div className="speaker-social">
                    <a href={facebook} target="_blank">
                        <FacebookOutlineIcon className="speaker-social-icon" width={32} height={32} />
                    </a>
                </div>
        }
        {
            twitter &&
                <div className="speaker-social">
                    <a href={twitter} target="_blank">
                        <TwitterOutlineIcon className="speaker-social-iconn" width={32} height={32} />
                    </a>
                </div>

        }
    </div>
);

SocialsLinks.propType = Props;

export default SocialsLinks;
